import React from 'react';

import style from "./Overview.scss";

export default function SkinTracksContainer({id, children}) {
    return (
        <div
            className={style.limbContainer}
        >
            { children }
        </div>
    );
}
